<button mat-button
        [matMenuTriggerFor]="tenantMenu"
        class="tenant-switcher__btn"
        [class.tenant-switcher__btn--production]="isProductionActive"
        [attr.aria-label]="'Switch tenant backend' + (isProductionActive ? ' — currently on a live production backend' : '')">
  @if (isProductionActive) {
    <mat-icon class="tenant-switcher__warn-icon">warning</mat-icon>
  }
  ENV: {{ tenants[activeKey].label }}
</button>

<mat-menu #tenantMenu="matMenu">
  @for (key of tenantKeys; track key) {
    @let tenant = tenants[key];
    <button mat-menu-item
            (click)="selectTenant(key)"
            [class.tenant-switcher__item--production]="tenant.productionBackend">
      <mat-icon>
        {{ activeKey === key ? 'radio_button_checked' : 'radio_button_unchecked' }}
      </mat-icon>
      <span>{{ tenant.label }}</span>
      @if (tenant.productionBackend) {
        <!-- aria-hidden="false" is required: MatIcon force-sets aria-hidden="true"
             unless the host declares it, which would mute the label below. -->
        <mat-icon class="tenant-switcher__warn-icon" aria-hidden="false" aria-label="live production backend">
          warning
        </mat-icon>
      }
    </button>
  }
</mat-menu>
